import $ from "jquery";

export default class Form {
    constructor() {
        this.initializeFormFields();
        this.attachBlurEvent();
        this.initializeFormSubmission();
    }

    initializeFormFields() {
        $('.form input, .form textarea').each((i, el) => {
            this.updateFieldState(el);
        });
    }

    attachBlurEvent() {
        $('.form input, .form textarea').on('blur', (e) => {
            this.updateFieldState(e.currentTarget);
        });
    }

    updateFieldState(el) {
        const value = el.value.trim();
        if (value.length > 0) {
            el.classList.add('filled');
        } else {
            this.removeEmptyValue(el);
        }
    }

    removeEmptyValue(el) {
        el.classList.remove('filled');
        el.value = '';
    }

    initializeFormSubmission() {
        const containers = document.querySelectorAll('[data-form-container]');

        containers.forEach(container => {
            const form = container.querySelector('form');
            if (!form) return;

            form.addEventListener('submit', (e) => {
                // Show loading overlay (now in the container, not the form)
                const loadingOverlay = container.querySelector('[data-form-loading]');
                if (loadingOverlay) {
                    loadingOverlay.classList.add('active');
                }

                // Disable submit button to prevent double submission
                const submitButton = form.querySelector('button[type="submit"]');
                if (submitButton) {
                    submitButton.disabled = true;
                }
            });
        });
    }
}
